import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllTasks,
  addTask,
  removeTask,
  updateTask,
} from '../actions/task.action'
import { Task, UpdateTaskThunkParams } from '@dataTypes/index'

type TaskState = {
  data: Task[] | null
  loading: boolean
  error: null
}

const initialState: TaskState = {
  data: null,
  loading: false,
  error: null,
}

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllTasks.fulfilled,
      (state, action: PayloadAction<Task[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllTasks.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllTasks.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(addTask.fulfilled, (state, action: PayloadAction<Task>) => {
      state.data = state.data
        ? [...state.data, action.payload]
        : [action.payload]
      state.loading = false
    })
    builder.addCase(addTask.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addTask.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateTask.fulfilled,
      (state, action: PayloadAction<UpdateTaskThunkParams>) => {
        const { id, body: updatedTask } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedTask }
        }
        state.loading = false
      },
    )
    builder.addCase(updateTask.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateTask.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeTask.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeTask.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeTask.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default tasksSlice.reducer
